import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable,of } from 'rxjs';
import { OrgSettingsService } from "../org-settings/org-settings.service";
import { AuthService } from "../auth/auth.service";
import { UserProfile } from "../models/userprofile";
import { switchMap, map  } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContentGuard implements CanActivate {
  private userProfile: UserProfile;
  private OrgId: string;

  constructor(
    private orgSettingsService: OrgSettingsService,
    private router: Router,
    private authService: AuthService
  ) {
    this.userProfile = this.authService.getClaims() as UserProfile;
    this.OrgId = this.userProfile.organization_id;
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    try {
      const organizationId = this.authService.currentUser.idTokenClaims["extension_organizationid"] as string;
      return this.orgSettingsService.checkPassiveMode(organizationId).pipe(
        map(isPassiveMode => {
          if (isPassiveMode) {
            return this.router.parseUrl('/home'); // Redirect to /home
          } else {
            return true; // Allow access to the /content route
          }
        })
      );
    } catch (error) {
      console.error("Error retrieving organization ID:", error);
      return of(false); // Deny access
    }
  }
  
}
